import { Component, Input, ViewChild } from '@angular/core';
import { PersonCredential } from 'src/app/shared/models/credential/personCredential';
import {
  EvidenceValue,
  IEvidenceSnapshotModel,
} from 'src/app/shared/models/credential/personScenarioEvidenceDetails';
import { CustomFieldEditorModalComponent } from '../../custom-field-editor-modal/custom-field-editor-modal.component';
import { PersonProfileService } from 'src/app/people/profile/person-profile.service';
import { ActivatedRoute } from '@angular/router';
import { AttributeService } from 'src/app/shared/services/attribute.service';
import { Person } from 'src/app/people/models/person';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { EntityCredentialSpecialtyEvidenceModel } from 'src/app/shared/models/credential/entityCredentialSpecialtyEvidenceModel.model';
import { GenericAttributeServiceFactory } from 'src/app/shared/services/genericAttributeServiceFactory.service';
import { AttributeUiType } from 'src/app/shared/models/attributes/attributeUiType';

@Component({
  selector: 'specialty-evidence-snapshot',
  templateUrl: 'specialty-evidence-snapshot.component.html',
  styleUrls: ['specialty-evidence-snapshot.component.scss'],
})
export class SpecialtyEvidenceSnapshotComponent {
  constructor(
    private route: ActivatedRoute,
    private attributeService: AttributeService,
    private personProfileService: PersonProfileService,
    private factory: GenericAttributeServiceFactory
  ) {}

  @Input() evidence: IEvidenceSnapshotModel;
  @Input() specialtyEvidenceModel: EntityCredentialSpecialtyEvidenceModel;
  /** only used with fields of type complex fields */
  @Input() showAllFields: boolean;
  @Input() openEvidenceFile: (filename: string, evidence: IEvidenceSnapshotModel) => void;

  @ViewChild(CustomFieldEditorModalComponent, { static: true }) //
  dialog: CustomFieldEditorModalComponent;

  get personId() {
    return this.route.parent.snapshot.params.personId;
  }

  notCredential = () => {
    return this.evidence?.evidenceType !== 'Credential';
  };

  asCredential = (): PersonCredential => {
    if (!this.evidence.evidenceValue.length) {
      return null; //hacky way to render never issued (empty) credentials in the credential-snapshot component
    }

    return this.evidence.evidenceValue[0] as PersonCredential;
  };

  openEvidenceImageInS3 = (fileName: EvidenceValue, evidence: IEvidenceSnapshotModel) =>
    this.openEvidenceFile(fileName as string, evidence);

  openEditAttributeModal = async () => {
    await Promise.all([
      this.personProfileService.getPerson(this.personId, false),
      this.attributeService.getAttributeDefinitions(),
    ]).then(([person, attributeDefinitions]: [Person, AttributeDefinition[]]) => {
      const attributes = person.attributes.filter(
        (a) => a.attributeDefinitionId == this.evidence.lookupValue
      );
      const attributeDefinition = attributeDefinitions.find(
        (a) => a.id === this.evidence.lookupValue
      );
      this.dialog.open(attributes, this.buildGenericAttributeService(attributeDefinition));
    });
  };

  private buildGenericAttributeService = (attributeDefinition: AttributeDefinition) =>
    this.factory.BuildForPersonOnApplication(
      this.personId,
      this.specialtyEvidenceModel.entityCredentialApplicationId,
      attributeDefinition
    );

  private isEditable() {
    return !this.specialtyEvidenceModel.evidenceSnapshotTakenDate &&
    (this.evidence.evidenceType === 'Skill' || this.evidence.evidenceType === 'CustomField');
  }

  showEditButton = () => (this.isEditable() ? !!this.evidence?.evidenceValue?.length : false);
  showAddButton = () => (this.isEditable() ? !this.evidence?.evidenceValue?.length : false);

  canClear = () => {
    if (!this.evidence?.evidenceValue?.length)
      return false;

    if (this.evidence.evidenceType === 'Skill')
      return true;

    if (this.evidence.evidenceType === 'CustomField')
      return this.evidence.attributeUiType === AttributeUiType.Document ? false : true;

    return false;
  };

  async onClearField() {
    const attributeDefinitions = await this.attributeService.getAttributeDefinitions();
    const attributeDefinition = attributeDefinitions.find(
      (a) => a.id === this.evidence.lookupValue
    );
    this.buildGenericAttributeService(attributeDefinition).deleteAttribute();
  }
}
